<header>
    <div class="header flex items-center">
        <span class="font-bold">VIGI</span>
    </div>
</header>
<div class="title-section h-10 flex items-center">
    <span class="ml-5">Your sales companion</span>
</div>
<img class="vigi-icon mx-auto mt-20" src="../../../assets/icons/bot-icon.png" />
<div class="flex items-center justify-center mt-9">
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="w-[180px] space-y-4">
        <input type="text" class="px-2 py-1 rounded-md border w-full placeholder:font-normal" placeholder="Email"
            formControlName="username" />

        <input type="password" class="px-2 py-1 rounded-md border w-full placeholder:font-normal" placeholder="Password"
            formControlName="password" />

        <button type="submit" class="bg-purple text-white px-4 py-2 rounded-md w-full" [disabled]="loginForm.invalid">
            Login
        </button>
    </form>
</div>
<div *ngIf="showSuccessPopup" class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
    <div class="bg-white p-6 rounded-lg shadow-lg text-center w-72">
        <p class="text-red-600 font-semibold mb-4">Invalid Credentials!</p>
        <button (click)="showSuccessPopup = false" class="bg-purple text-white px-4 py-2 rounded-md">
            OK
        </button>
    </div>
</div>